// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container da página */
.page-container {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 2rem auto;
  max-width: 960px;
  box-shadow: var(--shadow);
}

/* Cabeçalho */
.page-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem 0;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #f8fafc;
  border: 1px solid var(--border-color);
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
}

.patient-summary {
  margin-bottom: 1.5rem;
}

.patient-info-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.selected-procedures ul {
  padding-left: 1.2rem;
  margin-top: 0.5rem;
}

.selected-procedures li {
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.search-container {
  position: relative;
  margin-bottom: 1.5rem;
}

.search-container input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  outline: none;
  font-size: 0.9rem;
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
}

/* Lista de médicos */
.doctors-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.doctor-card {
  display: flex;
  gap: 1rem;
  background-color: #fff;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: var(--shadow);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.doctor-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
}

.doctor-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #f1f5f9;
  border-radius: 50%;
}

.doctor-info {
  flex: 1 1;
}

.doctor-info h3 {
  font-size: 1rem;
  font-weight: 600;
}

.doctor-specialty {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}

.doctor-procedures ul {
  list-style: none;
  padding-left: 0;
  margin-top: 0.5rem;
}

.doctor-procedures li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: var(--text-primary);
}

.procedure-price {
  font-weight: 600;
  color: var(--primary-color);
}

.doctor-price {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  min-width: 100px;
}

.price-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.price-value {
  font-weight: 600;
  font-size: 1rem;
  color: var(--primary-color);
}

.no-doctors {
  text-align: center;
  padding: 2rem;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/doctorSelectionPage.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B","sourcesContent":["/* Container da página */\n.page-container {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin: 2rem auto;\n  max-width: 960px;\n  box-shadow: var(--shadow);\n}\n\n/* Cabeçalho */\n.page-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 1rem 0;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background-color: #f8fafc;\n  border: 1px solid var(--border-color);\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.patient-summary {\n  margin-bottom: 1.5rem;\n}\n\n.patient-info-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.selected-procedures ul {\n  padding-left: 1.2rem;\n  margin-top: 0.5rem;\n}\n\n.selected-procedures li {\n  font-size: 0.875rem;\n  margin-bottom: 0.25rem;\n}\n\n.search-container {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n\n.search-container input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  outline: none;\n  font-size: 0.9rem;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n}\n\n/* Lista de médicos */\n.doctors-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.doctor-card {\n  display: flex;\n  gap: 1rem;\n  background-color: #fff;\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 1rem;\n  box-shadow: var(--shadow);\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.doctor-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);\n}\n\n.doctor-avatar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background-color: #f1f5f9;\n  border-radius: 50%;\n}\n\n.doctor-info {\n  flex: 1;\n}\n\n.doctor-info h3 {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.doctor-specialty {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.doctor-procedures ul {\n  list-style: none;\n  padding-left: 0;\n  margin-top: 0.5rem;\n}\n\n.doctor-procedures li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--text-primary);\n}\n\n.procedure-price {\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.doctor-price {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  min-width: 100px;\n}\n\n.price-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.price-value {\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--primary-color);\n}\n\n.no-doctors {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
